export const categories = {
	navTitle: "Categorias",
	title: "Categorias",
	subtitle: "Visualize, reordene crie e edite suas categorias de produtos.",
	searchPlaceholder: "Categoria, subcategoria ou produto",
	addCategoryBtn: "Adicionar categoria",
	amountOfCategories_one: "{{count}} categoria",
	amountOfCategories_other: "{{count}} categorias",
	filterByBtn: "Filtrar ordem",
	categoryEmptyState: {
		title: "Nenhuma categoria encontrada",
		description: "Ainda não há categorias cadastradas.",
	},
	subcategories_one: "{{count}} Subcategoria",
	subcategories_other: "{{count}} Subcategorias",
	products_one: "{{count}} Produto",
	products_other: "{{count}} Produtos",
	chartAccountName: "Plano de Contas",
	noCategoryDescription: "Ainda não há descrição para essa categoria.",
	addSubcategoryBtn: "Adicionar subcategoria em {{category}}",
	addProductBtn: "Adicionar produto em {{category}}",
	dialog: {
		create: {
			title: "Adicionar categoria",
			save: "Salvar categoria",
		},
		createSubcategory: {
			title: "Adicionar subcategoria",
			save: "Salvar subcategoria",
		},
		edit: {
			title: "Editar categoria",
			delete: "Excluir categoria",
			deleteTooltip: "Esta categoria possui produtos associados",
			save: "Salvar alterações",
		},
		form: {
			name: {
				label: "Nome",
				placeholder: "Definir nome da categoria",
				requiredName: "Nome é obrigatório",
			},
			priority: {
				label: "Posição de prioridade",
				tooltip: "Ordem em que aparecerá entre as categorias.",
				placeholder: "Defina a posição ou reordene na lista depois",
				requiredPriority: "Nível de prioridade é obrigatório",
				maxPriority: "Este número é muito grande",
			},
			printOrder: {
				label: "Fase de entrega",
				tooltip:
					"Categoria para faseamento de cursos automáticos.<br>O operador conseguirá reordenar no PDV se necessário. ",
				placeholder: "Atribuir fase automática",
				requiredPrintOrder: "Fase da categoria é obrigatória",
				invalidPrintOrder: "Fase da categoria inválida",
			},
			chartAccount: {
				label: "Plano de contas",
				tooltip: "O plano de contas define a conta contábil da categoria.",
				placeholder: "Selecionar ",
			},
			description: {
				label: "Descrição da categoria",
				placeholder: "Descrever categoria",
			},
		},
	},
	modal: {
		delete: {
			title: "Deseja excluir a categoria? ",
			description:
				"Ao confirmar, categoria será excluída e a ação não poderá ser revertida.",
			confirm: "Excluir categoria",
			cancel: "Cancelar",
		},
	},
	inputImage: {
		addImage: "Adicionar imagem",
		infoTypeAndSize: "Tipo de arquivo {{type}} até {{size}}MB",
		infoOnlyType: "Tipo de arquivo {{type}}",
		infoOnlyMaxSize: "{{size}}MB",
	},
	productToOrg: {
		nameLabel: "Nome",
		kindLabel: "Tipo do produto",
		kindPlaceholder: "Selecione o tipo do produto",
		hasAlcoholLabel: "Contém Álcool",
		createDialogTitle: "Criar produto",
		editDialogTitle: "Editar produto",
		createProductBtn: "Criar produto",
		editProductBtn: "Editar produto",
	},
};
